import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employee: [],
    employeeShow: null,
    employeeAll: [],
    employeeAll_role: [],
    employeeListGroupsAndWorkTypes: [],
    pageData: null,
    employeeReports: {},
    employeeReportsDays: [],
  },
  mutations: {
    setEmployeeData(state, employee) {
      state.employee = employee
    },
    setEmployeeShow(state, payload) {
      state.employeeShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setEmployeeAll(state, payload) {
      state.employeeAll = payload
    },
    setEmployeeAll_role(state, payload) {
      state.employeeAll_role = payload
    },
    setEmployeeListGroupsAndWorkTypes(state, payload) {
      state.employeeListGroupsAndWorkTypes = payload
    },
    setEmployeeReports(state, payload) {
      state.employeeReports = payload ? payload : {}
    },
    setEmployeeReportsDays(state, payload) {
      state.employeeReportsDays = payload
    },
  },
  getters: {
    employeeData: (state) => {
      return state.employee
    },
    employeeShow: (state) => {
      return state.employeeShow
    },
    employeeAll: (state) => {
      return state.employeeAll
    },
    employeeAll_role: (state) => {
      return state.employeeAll_role
    },
    pageData: (state) => {
      return state.pageData
    },
    employeeListGroupsAndWorkTypes: (state) => {
      return state.employeeListGroupsAndWorkTypes
    },
    employeeReports: (state) => {
      return state.employeeReports
    },
    employeeReportsDays: (state) => {
      return state.employeeReportsDays
    },
  },
  actions: {
    employeeGrid({ commit, rootState }, payload) {
      commit('setLoadingAnimation', true, { root: true })
      return new Promise((resolve, reject) => {
        let limit = payload.limit
        let page = payload.page
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/employee/grid?limit=' +
            limit +
            '&page=' +
            page +
            '&order[]=last_name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeData', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onEmployeeAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/work-list?limit=0' + '&order[]=id:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeListGroupsAndWorkTypes({ commit, rootState }, { limit, page, filters, filter_1, sort, search },) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/employee/work-list?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=id:asc'
      }
      if (filters) url = url + filters
      if (filter_1) {
        if (filter_1.status) url =  url + '&additional_data[work_day_status]=' + filter_1.status
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeListGroupsAndWorkTypes', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onEmployeeAll_role({ commit, rootState }, roleId) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/employee/grid?limit=0&filter[]=work_role_id:' +
            roleId +
            '&order[]=id:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeAll_role', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeUpdate({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    employeeRegister({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/register',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    employeeCreate({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    employeeDelete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeReports({ commit, rootState }, { employee_id, start, end }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/employee/reports/' +
            employee_id +
            '?start=' +
            start +
            '&end=' +
            end +
            '&order[]=id:desc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeReports', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeReportsDays({ commit, rootState }, { employee_id, start, end }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/employee/reports-days/' +
            employee_id +
            '?start=' +
            start +
            '&end=' +
            end +
            '&order[]=id:desc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeReportsDays', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
